
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/watches/[collection]/[model]/[sku]",
      function () {
        return require("private-next-pages/[lang]/watches/[collection]/[model]/[sku].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/watches/[collection]/[model]/[sku]"])
      });
    }
  